import {
  PrintParamsData,
  PrintInjectData,
  PrintConfig
} from "../print.interface";
import { PrintService } from "../print.service";

import { DialogService, Dialog } from "../../dialog/index";

export class Print {
  constructor(
    private _printService: PrintService,
    private _dialogService: DialogService,
    private _data: PrintInjectData,
    private _config: PrintConfig
  ) {}

  public printing = false;
  private _loader: Dialog;

  public get component(): any {
    return this._data.component;
  }
  public get params(): PrintParamsData {
    return this._data.params;
  }

  public preparePrint() {
    this.printing = true;
    this.showLoader();
  }

  public print() {
    this.closeLoader();
    this._printService.onPrint.emit(this);
    window.print();

    // Preserve component rendered if debug_mode
    if (this._config.debug_mode) return;
    this.printing = false;
  }

  public showLoader() {
    this._loader = this._dialogService.loading("Preparando impressÃ£o...");
  }

  public closeLoader() {
    if (this._loader) {
      this._loader.close();
    }
  }
}
